module.exports = __webpack_public_path__ + "img/hard-braking.c6f4736d.png";